import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const appModule = {
  namespaced: true,
  state: {
    isLoading: false,
    isInitialized: false,
    apiVersion: 0
  },
  getters,
  actions,
  mutations
}

export default appModule
